import React from 'react';
import ReactDOM from 'react-dom/client';

export const parseDataAttributes = (element) => {
    const props = {};

    for (const attr of element.attributes) {
        if (attr.name.startsWith('data-') && attr.name !== 'data-mount') {
            // Remove "data-" and Convert kebab-case to camelCase
            const propName = attr.name.replace('data-', '').replace(/-./g, (x) => x[1].toUpperCase());

            try {
                // Try parsing JSON for arrays/objects; fallback to strings/booleans
                props[propName] = JSON.parse(attr.value);
            } catch {
                props[propName] = attr.value === 'true' ? true : attr.value === 'false' ? false : attr.value;
            }
        }
    }

    return props;
};

export const ReactMount = (componentMap) => {
    const mountPoints = document.querySelectorAll('[data-mount]');

    mountPoints.forEach((element) => {
        const componentName = element.getAttribute('data-mount');
        // Get the dynamic import function
        const ComponentPromise = componentMap[componentName];

        if (ComponentPromise) {
            const props = parseDataAttributes(element);

            // Dynamically load the component and render it
            ComponentPromise()
                .then((ComponentModule) => {
                    // Get the default export and render in the root
                    // eslint-disable-next-line no-unused-vars
                    const Component = ComponentModule.default;

                    const root = ReactDOM.createRoot(element);

                    root.render(
                        <React.Suspense fallback={<div>Loading...</div>}>
                            <Component {...props} />
                        </React.Suspense>,
                    );
                })
                .catch((error) => {
                    console.error(`Error loading component "${componentName}":`, error);
                });
        } else {
            console.error(`Component "${componentName}" not found.`);
        }
    });
};
